<template>
  <div class="search-wrap" @movestart="move">
    <header>
      <input type="text" v-model="value" placeholder="可搜索学校"><span @click="close">取 消</span>
    </header>
    <ul class="content">
      <li class="check-item" v-for="item of filterResult" :key="item" @click="checkItem(item)" :class="{checked: item == check}">{{item}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'demandWrap',
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      value: '',
      check: ''
    }
  },
  computed: {
    filterResult () {
      return this.list.filter(value => new RegExp(this.value, 'i').test(value))
    }
  },
  methods: {
    move (e) {
      e.preventDefault()
    },
    close () {
      this.value = ''
      this.check = ''
      this.$emit('close')
    },
    checkItem (item) {
      this.value = ''
      this.check = item
      this.$emit('check', item)
      this.$emit('close')
    }
  }
}
</script>
<style lang="less">
.search-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100vh;
  background-color: rgba(0, 0, 0, .7);
  header {
    font-size: 14px;
    display: flex;
    justify-content: space-around;
    align-content: center;
    padding: 5px;
    line-height: 30px;
    background-color: #d9d9d9;
    input {
      height: 30px;
      width: 8.5rem;
      outline: none;
      border-radius: 3px;
      border: none;
      font-size: 14px;
      text-indent: 6px;
    }
  }
  .content {
    font-size: 14px;
    padding-top: 100px;
    padding-bottom: 400px;
    background-color: #fff;
    padding: 0;
    margin: 0;
    max-height: 100vh;
    overflow: auto;
    li {
      list-style: none;
      height: 40px;
      line-height: 40px;
      background-color: #fff;
      border-top: 1px solid #eee;
      transition: all .5s;
    }
    li.checked {
      background-color: #eee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bySearch.vue